<template>
  <!-- 评分卡 -->
  <div class="score-card">
    <a-card style="margin-bottom: 10px">
      <SearchView
        :renderItem="searchSchema"
        :isExpandShowOrNot="false"
        :initialValues="initSearchForm"
        @fetchSearch="handleSearch"
      ></SearchView>
    </a-card>
    <a-card>
      <div class="text-right">
        <a-button type="primary" icon="plus" @click="toAddRecord">
          新增记录
        </a-button>
      </div>
      <TableView
        :data="tableData"
        :columns="tableColumns"
        :pagination="pageData"
        :loading="tableLoading"
        :scroll="{ x: 800 }"
        @handlePagination="handleClickPage"
      >
        <template v-slot:action="{ tableRow }">
          <a-button
            type="link"
            size="small"
            @click="_download(tableRow)"
            v-if="tableRow.cardId == ''"
          >
            下载PDF
          </a-button>
          <a-button
            type="link"
            size="small"
            @click="_download(tableRow)"
            v-if="tableRow.cardId != ''"
          >
            结果导出
          </a-button>
          <a-divider type="vertical" />
          <a-button type="link" size="small" @click="handleView(tableRow)">
            查看
          </a-button>
          <a-divider type="vertical" />
          <a-button type="link" size="small" @click="manualUpdate(tableRow)">
            人工调整
          </a-button>
        </template>
      </TableView>
    </a-card>

    <!-- 人工调整modal -->
    <a-modal
      title="人工调整"
      :visible="updateModalVisible"
      @ok="handleUpdateModalOk"
      @cancel="handleUpdateModalCancel"
      :mask-closable="false"
    >
      <CardEdit
        ref="cardEdit"
        :schema="UPDATE_MODAL_SCHEMA"
        :source-data="updateSourceData"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        :defaultColXs="defaultColXs"
        :defaultColSm="defaultColSm"
        :defaultColMd="defaultColMd"
        :defaultColLg="defaultColLg"
        :defaultColXl="defaultColXl"
      >
        <template v-slot:remark="slotProps">
          <a-textarea
            placeholder="请输入"
            :maxLength="1000"
            allow-clear
            v-decorator="[
              slotProps.item.key,
              {
                initialValue: slotProps.item.value,
                rules: slotProps.item.rules,
              },
            ]"
          />
        </template>
      </CardEdit>
    </a-modal>
  </div>
</template>

<script>
import { SearchView, TableView, CardEdit } from 'lxfintech-fe'
import mixin from './mixin'
import { getTableData, download, manualUpdate, getAllRating } from './api'
import cloneDeep from 'lodash/cloneDeep'

export default {
  name: 'score-card',
  mixins: [mixin],
  data() {
    const initSearchForm = { typeCard: '', startTime: '', endTime: '', id: '' }
    const searchForm = cloneDeep(initSearchForm)
    return {
      initSearchForm,
      searchForm,
      id: '',
      tableLoading: false,
      updateModalVisible: false,
    }
  },
  mounted() {
    // 获取评分卡类型表
    this._getCardList()
    this._getTableData(this.initSearchForm)
  },
  methods: {
    _getCardList() {
      this.cardList.forEach(item => {
        item.text = item.label
      })
      getAllRating().then(({ data }) => {
        var list = []
        data.forEach(item => {
          list.push({ value: item.id, text: item.cardName })
        })
        this.cardList = this.cardList.concat(list)
        this.searchSchema[0].selectList = this.cardList
      })
    },
    changeLevel(manualLevel) {
      switch (manualLevel) {
        case 'AAA':
          return 1
        case 'AA+':
          return 2
        case 'AA':
          return 3
        case 'AA-':
          return 4
        case 'A+':
          return 5
        case 'A':
          return 6
        case 'A-':
          return 7
        case 'BBB':
          return 8
        case 'BB':
          return 9
        case 'B':
          return 10
      }
    },
    // 获取表格数据
    _getTableData(searchForm) {
      this.tableLoading = true
      const { current, pageSize } = this.pageData

      const formData = {
        ...searchForm,
        size: pageSize,
        current,
        customerCode: this.$store.getters['app/company'].code,
      }
      getTableData(formData).then(({ data: { total, records } }) => {
        this.pageData.total = total
        records.filter(item => {
          item.manualLevelStr = this.changeLevel(item.manualLevel) || ''
        })
        this.tableData = records
        this.tableLoading = false
      })
    },
    _download(row) {
      download(row.id)
    },
    handleView(row) {
      this.$router.push({
        name: 'client-center-score-card-detail',
        // params: { recordId: row.id },
        params: { recordId: row },
      })
    },
    manualUpdate(row) {
      this.id = row.id
      this.updateSourceData.levelStr = row.levelStr
      this.updateSourceData.manualLevel = row.manualLevelStr
      this.updateSourceData.remark = row.remark
      this.updateModalVisible = true
    },
    async handleUpdateModalOk() {
      try {
        const values = await this.$refs.cardEdit.handleSubmit()
        if (values) {
          this.doUpdate(values)
        }
      } catch (error) {
        console.error(error)
      }
    },
    async doUpdate(values) {
      const params = { id: this.id, ...values }
      try {
        await manualUpdate(params)
        this.handleUpdateModalCancel()
        this._getTableData(this.searchForm)
      } catch (error) {
        console.error(error)
      }
    },
    handleUpdateModalCancel() {
      this.$refs.cardEdit.handleReset()
      this.updateModalVisible = false
    },
    toAddRecord() {
      this.$router.push({ name: 'client-center-score-card-add' })
    },
  },
  components: {
    SearchView,
    TableView,
    CardEdit,
  },
}
</script>

<style></style>
